import { notAuthorised } from "../request";

export async function resetPassword(values: { email: string }) {
  await notAuthorised.request({
    method: "POST",
    url: "/api/frontend/reset-password/",
    data: {
      email: values.email.toLowerCase(),
    }
  });
}
